import { useMutation } from "@/compat/reactQuery";
import riskAssessmentAcknowledgementService from "../../services/riskAssessmentAcknowledgementService";

const useAcknowledgeRiskAssessment = () => useMutation(riskAssessmentAcknowledgementService.acknowledge);

export default useAcknowledgeRiskAssessment;
